import { render, staticRenderFns } from "./SGSST.vue?vue&type=template&id=ce3b8c96&scoped=true"
import script from "./SGSST.vue?vue&type=script&lang=js"
export * from "./SGSST.vue?vue&type=script&lang=js"
import style0 from "./SGSST.vue?vue&type=style&index=0&id=ce3b8c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3b8c96",
  null
  
)

export default component.exports